import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";

import {
  Bar,
  Line,
  Pie,
  Doughnut,
  Radar,
  PolarArea,
  Scatter,
  Bubble,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { ProgressSpinner } from "primereact/progressspinner";
import { topSaleGarment, topSaleService } from "../../../services/TopSale/TopSaleServices";
import { GraphColorCode } from "./GraphColorCode";
import AnalyticsSchedularModal from "../../AnalyticsSchedularModal";
import { formatDateNew, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const TopGarmentsNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [modalMenuVisible, setModalMenuVisible] = useState(false);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const userRole = userProfileRole;
  const brandOfferModal = brandProfileData.brandOffModel;
  const brandId = brandProfileData.id;
  const [topQuantityServiceData, setTopQuantityServiceData] = useState([]);
  const [topSaleServiceData, setTopSaleServiceData] = useState([]);

  const [topQuantityServiceDataNew, setTopQuantityServiceDataNew] = useState(
    {}
  );
  const [topSaleServiceDataNew, setTopSaleServiceDataNew] = useState({});

  const [totalSaleServiceData, setTotalSaleServiceData] = useState(0);
  const [totalQuantityServiceData, setTotalQuantityServiceData] = useState(0);
  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [analyticsSchedularModalVisible, setAnalyticsSchedularModalVisible] =
    useState(false);
  const [schedularDate, setSchedularDate] = useState({});

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
    setInitialDateValue(newSchedular.startDate)
    setEndDate(newSchedular.endDate)
  };

  const handleCalendarModal = () => {
    setAnalyticsSchedularModalVisible(true);
  };

  const chartsGradient = GraphColorCode

  const chartsColor = GraphColorCode

  const [loading, setLoading] = useState(false);
  const fetchDataSale = (data) => {
    setLoading(true);
    topSaleGarment(data)
      .then((response) => {
        if (!response.data.error) {
          const sortedData = response.data;
          const resultTopQuantityServiceData = sortedData.map(
            (item, index) => ({
              ...item,
              value: item.totalQuantity,
              gradientCenterColor:
                chartsGradient[index % chartsGradient.length], // Assuming getRandomColor() generates a random color
              color: chartsColor[index % chartsColor.length],
            })
          );
          const resultTopSaleServiceData = sortedData.map((item, index) => ({
            ...item,
            value: item.totalSales,
            gradientCenterColor: chartsGradient[index % chartsGradient.length], // Assuming getRandomColor() generates a random color
            color: chartsColor[index % chartsColor.length],
          }));
          setTopSaleServiceData(resultTopSaleServiceData);
          setTopQuantityServiceData(resultTopQuantityServiceData);

          const resultTopSaleServiceDataNew = {
            labels: resultTopSaleServiceData?.map((item) =>
              item.name.replace(/_/g, " ")
            ),
            datasets: [
              {
                label: ["Sale"],
                data: resultTopSaleServiceData?.map((item) => item.value),
                backgroundColor: resultTopSaleServiceData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };

          const resultTopQuantityServiceDataNew = {
            labels: resultTopQuantityServiceData?.map((item) =>
              item.name.replace(/_/g, " ")
            ),
            datasets: [
              {
                label: ["Quantity"],
                data: resultTopQuantityServiceData?.map((item) => item.value),
                backgroundColor: resultTopQuantityServiceData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };

          setTopSaleServiceDataNew(resultTopSaleServiceDataNew);
          setTopQuantityServiceDataNew(resultTopQuantityServiceDataNew);

          const totalQuantity = sortedData.reduce(
            (acc, item) => acc + item.totalQuantity,
            0
          );
          const totalSales = sortedData.reduce(
            (acc, item) => acc + item.totalSales,
            0
          );
          setTotalSaleServiceData(totalSales);
          setTotalQuantityServiceData(totalQuantity);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  const initializeVariable = () => {
    setTopSaleServiceData([]);
    setTopQuantityServiceData([]);
  };

  const initialDate = new Date(startDate);
  initialDate.setDate(initialDate.getDate() - 30);

  const [initialDateValue, setInitialDateValue] = useState(initialDate)
  

  const dataSale = {
    brandIds: [brandId],
    // startDate: schedularDate?.startDate
    //   ? schedularDate.startDate
    //   : brandProfileData.createdDate !== null
    //   ? brandProfileData.createdDate
    //   : "2024-01-01T00:00:00Z",
    startDate: schedularDate?.startDate
                ? localeDateStartDate(new Date(schedularDate.startDate))
                : localeDateStartDate(new Date(initialDate)),
    endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate.endDate)) : localeDateEndDate(new Date(endDate)),
    sortBy: "sale",
    statusIn: [
      "BOOKED",
      "INPROCESS",
      "PROCESSED",
      "IN_WAREHOUSE",
      "DELIVERED",
      "DONE",
      "CANCEL",
      "UNPROCESSED",
      "OUT_FOR_DELIVERY",
      "DELAY",
    ],
  };

  useEffect(() => {
    initializeVariable();

    fetchDataSale(dataSale);
  }, [schedularDate]);

  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "bottom" } },
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/AnalyticsList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Top Garments
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div class="flex flex-1 justify-content-center align-items-center">
       <p className=" text-2xl  font-bold ">Period - {formatDateNew(initialDateValue)} - {formatDateNew(endDate)}</p>
      </div>
      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">TOP QUANTITY GARMENTS</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">
                Loading Top Quantity Garments...
              </p>
            </div>
          ) : topQuantityServiceData.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 400 }}>
                  <Doughnut
                    data={topQuantityServiceDataNew}
                    options={chartOptions}
                  />
                </div>
              </div>
              <div className="mx-4 my-3 flex justify-content-center">
                <h4>Total Quantity : {totalQuantityServiceData}</h4>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Quantity Found</p>
            </div>
          )}
        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">TOP SALE GARMENTS</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Top Sale Garments...</p>
            </div>
          ) : topSaleServiceData.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 400 }}>
                  <Doughnut
                    data={topSaleServiceDataNew}
                    options={chartOptions}
                  />
                </div>
              </div>
              <div className="mx-4 my-3 flex justify-content-center">
                  <h4>Total Sale : {storeLocalData?.currencySymbol} {totalSaleServiceData.toFixed(2)}</h4>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Sale Found</p>
            </div>
          )}
        </div>
      </div>
      <AnalyticsSchedularModal
        analyticsSchedularModalVisible={analyticsSchedularModalVisible}
        setAnalyticsSchedularModalVisible={setAnalyticsSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default TopGarmentsNew;
